import React from 'react'
import Component from 'components/component'
import BrandingPositionInput from './branding-position-input'
import { Modal } from 'components/modal'

const watermarks = {
  left_top: require(`assets/watermarks/branding_1080p_tl.png`),
  center_top: require(`assets/watermarks/branding_1080p_tc.png`),
  right_top: require(`assets/watermarks/branding_1080p_tr.png`),
  left_bottom: require(`assets/watermarks/branding_1080p_bl.png`),
  center_bottom: require(`assets/watermarks/branding_1080p_bc.png`),
  right_bottom: require(`assets/watermarks/branding_1080p_br.png`),
  onscreen_credits_left_top: require(`assets/watermarks/onscreen_credits_1080_tl.png`),
  onscreen_credits_center_top: require(`assets/watermarks/onscreen_credits_1080_tc.png`),
  onscreen_credits_right_top: require(`assets/watermarks/onscreen_credits_1080_tr.png`),
  onscreen_credits_left_bottom: require(`assets/watermarks/onscreen_credits_1080_bl.png`),
  onscreen_credits_center_bottom: require(`assets/watermarks/onscreen_credits_1080_bc.png`),
  onscreen_credits_right_bottom: require(`assets/watermarks/onscreen_credits_1080_br.png`),
}

export default class BrandingPosition extends Component {
  static defaultProps = {
    image: require('./example-1080.png'),
    position: 'left_top',
    onClose() {},
    isOncreenCredits: false,
    worldExclusive: false,
    exclusive: false,
  }

  state = {
    position: this.props.position,
  }

  onChange = ev => {
    this.setState({
      position: ev.target.value,
    })
  }

  save = ev => {
    if (this.props.save) {
      this.props.save(this.state.position)
    }

    this.props.onClose()
  }

  render() {
    return (
      <Modal onClose={this.save}>
        <div className="popup-bp">
          <div className="branding-positions">
            <div className="branding-positions-img">
              <img
                src={
                  watermarks[
                    (this.props.worldExclusive
                      ? 'we_'
                      : this.props.exclusive
                      ? 'credit_'
                      : this.props.isOncreenCredits
                      ? 'onscreen_credits_'
                      : '') + this.state.position
                  ]
                }
                className="branding-position__img"
                style={{
                  backgroundImage: `url(${this.props.image})`,
                  backgroundSize: 'cover',
                  backgroundColor: '#f2f2f2',
                  width: '100%',
                }}
                alt=""
              />
            </div>
            <div className="branding-positions-subtitle">Branding position</div>
            <BrandingPositionInput
              onChange={this.onChange}
              name="position"
              value={this.state.position}
              worldExclusive={this.props.worldExclusive}
            />
            {this.props.save && (
              <div className="branding-positions-button">
                <button
                  type="button"
                  className="button button--small-green"
                  onClick={this.save}
                >
                  Save position
                </button>
              </div>
            )}
          </div>
        </div>
      </Modal>
    )
  }
}
